<template>
  <section id="services" class="main-services">
    <img class="service-top-img" src="static/sections/service_top.jpg" alt="Servicios">
    <v-container grid-list-xs py-5 fluid>
      <v-layout row wrap>
        <v-flex xs10 lg4 v-for="(service, i) in services" :key="i"
          @mouseenter="cardComponent = 'app-back-service-card'"
          @mouseleave="cardComponent = 'app-front-service-card'"
        >
          <transition name="slide-in-out" mode="out-in">
            <component
            :is="service.component"
            @cardComponent="service.component = $event"
            :serviceStyle="service.style"
            :serviceBackStyle="service.backStyle"
            :serviceIcon="service.icon"
            :serviceTitle="service.title"
            :serviceOptions="service.options"

            :serviceComponent="service.frontComponent"
            :serviceBackComponent="service.backComponent"
            @dialog="dialog = $event"
            ></component>
          </transition>
          <app-contact-dialog :dialog="dialog" @dialog="dialog = $event"></app-contact-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import WebServiceCard from './service_cards/WebServiceCard.vue';
import WebBackServiceCard from './service_cards/WebBackServiceCard.vue';
import GraficServiceCard from './service_cards/GraficServiceCard.vue';
import GraficBackServiceCard from './service_cards/GraficBackServiceCard.vue';
import MarketingServiceCard from './service_cards/MarketingServiceCard.vue';
import MarketingBackServiceCard from './service_cards/MarketingBackServiceCard.vue';
import ContactDialog from '../addons/ContactDialog.vue'
export default {
  data () {
    return {
      dialog: false,
      services:[
       {
          title: 'Web',
          icon: 'web',
          options: ['Diseño Web', 'eCommerce', 'Posicionamiento', 'Marketing'],
          style: 'web-service-card',
          backStyle: 'web-back-service',
          component: 'app-web-service-card',
          frontComponent: 'app-web-service-card',
          backComponent: 'app-web-back-service-card'
        },
        {
          title: 'Graficos',
          icon: 'create',
          options: ['Diseño de logo e Imagen', 'Folletería papelería', 'Sublimación (Remeras,Gorros,etc)', 'Plantillas para mercado libre'],
          style: 'grafic-service-card',
          backStyle: 'grafic-back-service',
          component: 'app-grafic-service-card',
          frontComponent: 'app-grafic-service-card',
          backComponent: 'app-grafic-back-service-card'
        },
        {
          title: 'Marketing',
          icon: 'business_center',
          options: ['Asesoría Planes de Negocio', 'Publicidad en mercado libre', 'Publicidad en redes sociales ', 'E-mail Marketing', 'CEO & Analítica Web'],
          style: 'marketing-service-card',
          backStyle: 'marketing-back-service',
          component: 'app-marketing-service-card',
          frontComponent: 'app-marketing-service-card',
          backComponent: 'app-marketing-back-service-card'
        }
      ],
    }
  },
  components: {
    'app-web-service-card': WebServiceCard,
    'app-web-back-service-card': WebBackServiceCard,
    'app-grafic-service-card': GraficServiceCard,
    'app-grafic-back-service-card': GraficBackServiceCard,
    'app-marketing-service-card': MarketingServiceCard,
    'app-marketing-back-service-card': MarketingBackServiceCard,
    'app-contact-dialog': ContactDialog,
  }
}
</script>

<style scoped>

.service-top-img {
  width: 120%;
  height: 320px;
  position: relative;
  left: -10%;
  transform: translateY(-15%) rotate(3deg);
}

.main-services {
  background-color: #ececec;
}

.slide-in-out-enter-active {
  animation: slide-in .7s forwards;
}

.slide-in-out-leave-active {
  animation: slide-out .7s forwards;
}

@keyframes slide-in {
  from {transform: rotateY(90deg)}
  to {transform: rotateY(0)}
}

@keyframes slide-out {
  from {transform: rotateY(0)}
  to {transform: rotateY(90deg)}
}

#services::after {
  content: "";
  display: block;
  position: relative;
  left: -10%;
  z-index: 1;
  width: 120%;
  height: 250px;
  background-image: url('/static/sections/service_bottom.jpg');
  transform: translateY(15%) rotate(3deg)
}

@media screen and (max-width: 780px) {
  .service-top-img {
    height: 150px;
  }

  #services::after {
    height: 150px;
  }

}
</style>





// WEBPACK FOOTER //
// src/components/sections/Services.vue